import StepperFormComposer from '../../composers/FormsStepsTevaComposer'

export default function StepperFormPage(): JSX.Element {
  return <StepperFormComposer />;
}
